export function groupByLeague(data) {
  const matches = data?.matches ?? data?.data?.matches ?? [];
  if (!Array.isArray(matches)) return [];

  const leagueMap = new Map();

  for (const match of matches) {
    const league = match.league || {};
    const leagueId = league.id ?? match.leagueId;
    if (leagueId == null) continue;

    if (!leagueMap.has(leagueId)) {
      leagueMap.set(leagueId, {
        league: { ...league, id: leagueId },
        matches: [],
      });
    }

    leagueMap.get(leagueId).matches.push(match);
  }

  return Array.from(leagueMap.values());
}

export function mergeLeagueGroups(prev, next) {
  const leagueMap = new Map(
    prev.map((group) => [
      group.league?.id,
      { league: group.league, matches: [...group.matches] },
    ]),
  );

  for (const { league, matches } of next) {
    const leagueId = league?.id;

    if (leagueMap.has(leagueId)) {
      leagueMap.get(leagueId).matches.push(...matches);
    } else {
      leagueMap.set(leagueId, { league, matches: [...matches] });
    }
  }

  return Array.from(leagueMap.values());
}
